import type { FC } from "react"
import React from "react"

import styled from "styled-components"

const Container = styled.div<{ size: number; color: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    * {
      fill: ${({ color }) => color};
    }
  }
`

const Spinner: FC<{
  size?: number
  color?: string
  style?: React.CSSProperties
}> = ({ size = 70, color = `var(--blue)`, style }) => {
  return (
    <Container size={size} color={color} style={{ ...style }}>
      <svg
        version="1.1"
        id="L4"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 55 100"
        enableBackground="new 0 0 0 0"
        xmlSpace="preserve"
      >
        <circle fill="#fff" stroke="none" cx="6" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>
        <circle fill="#fff" stroke="none" cx="26" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>
        <circle fill="#fff" stroke="none" cx="46" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.3"
          />
        </circle>
      </svg>
    </Container>
  )
}

export const SpinnerCircle: React.FC<{
  size?: number
  backgroundColor?: string
  spinnerColor?: string
  speed?: number
}> = ({
  size = 24,
  backgroundColor = `#d1d5db`,
  spinnerColor = `#3b82f6`,
  speed = 0.75,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>
        {`
          @keyframes spin {
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
      <path
        d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
        fill={backgroundColor}
      />
      <path
        // eslint-disable-next-line max-len
        d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
        fill={spinnerColor}
        style={{
          transformOrigin: `center`,
          animation: `spin ${speed}s infinite linear`,
        }}
      />
    </svg>
  )
}

export default Spinner
